module.exports = __webpack_public_path__ + "media/assets/illustrations/the-study-white-a75e059e9ad2982e9f32e9ac0256671a.svg";